import React from 'react';
import { ProFormDependency, ProFormSelect } from '@ant-design/pro-form';
import { useLazyQuery, gql } from '@apollo/client';
import { Empty, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import { displayFacDept } from '../../../utils';
import { PLACEHOLDER } from 'constants/form';

const GET_SELECT_PASS_ROLE = gql`
  query GET_SELECT_PASS_ROLE($ids: [ID!]) {
    users(ids: $ids) {
      id
      roles {
        id
        role {
          id
          name
        }
        faculty {
          id
          name
          abbreviation
        }
        department {
          id
          name
          abbreviation
        }
      }
    }
  }
`;
const { Text } = Typography;

const SelectPassRole = ({ form, ...props }) => {
  const [getRole, { data, loading }] = useLazyQuery(GET_SELECT_PASS_ROLE, {
    onCompleted: ({ users }) => {
      // check passFrom have the passRole
      // console.log(form.getFieldValue('passRole'));
      // console.log(users);
      if (
        !users[0].roles.some(({ id }) => id === form.getFieldValue('passRole'))
      ) {
        form.setFieldsValue({ passRole: undefined });
      }
    },
  });

  return (
    <ProFormDependency name={['passFrom']}>
      {({ passFrom }) => {
        return (
          <ProFormSelect
            placeholder={PLACEHOLDER.PLEASE_SELECT}
            fieldProps={{
              notFoundContent: data ? (
                <Empty />
              ) : (
                <Empty description="Please select user first" />
              ),
              optionItemRender({ department, faculty, label }) {
                return (
                  <Space direction="vertical">
                    {label}
                    <Text type="secondary">
                      {displayFacDept({
                        department: department,
                        faculty: faculty,
                        prefix: false,
                      })}
                    </Text>
                  </Space>
                );
              },
            }}
            params={{ passFrom, data, loading }}
            width="xl"
            name="passRole"
            debounceTime={process.env.REACT_APP_DEBOUNCE_TIME}
            request={async ({ passFrom, data, loading }) => {
              // form.setFieldsValue({ passRole: undefined });
              if (!passFrom) return [];
              if (!loading && (!data || data.users?.[0].id !== passFrom)) {
                getRole({ variables: { ids: [passFrom] } });
              }
              const options = data?.users?.[0].roles.map(
                ({ id, role, department, faculty }) => ({
                  value: id,
                  label: role.name,
                  department,
                  faculty,
                })
              );
              return options;
            }}
            rules={[
              {
                required: true,
              },
            ]}
            {...props}
          />
        );
      }}
    </ProFormDependency>
  );
};

SelectPassRole.propTypes = {
  form: PropTypes.object.isRequired,
};

export default SelectPassRole;
